import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  carrierCoverageTitle: {
    defaultMessage: 'Carrier coverage included by default',
    id: 'CzkDvp',
    description: 'popover title informing user service includes carrier insurance automatically',
  },
  parcelGuardNotAvailable: {
    defaultMessage: 'ParcelGuard not available for this destination. Learn more about terms and coverage.',
    id: '2z0NTj',
    description: 'links to terms and coverage if ParcelGuard is not available',
  },
  highOrderValue: {
    defaultMessage: 'Protect high value orders with insurance',
    id: 'sYyV2J',
    description: 'info regarding high value orders',
  },
  unknownInsuranceProvider: {
    defaultMessage: '{insuranceProviderName} is no longer available. Please select a different insurance option.',
    id: 'AbIxBo',
    description: 'Error message when the insurance provider is no longer available',
  },
  insuranceNotAvailable: {
    defaultMessage: 'Not available for this destination.',
    id: 'VGv0+Q',
    description: 'no insurance is available for selected destination',
  },
  maximumCoverage: {
    defaultMessage: 'Maximum coverage value is {amount}',
    id: 'UU3Rwc',
    description: 'warning that the insured value has exceeded the maximum coverage value',
  },
  insureForHeader: {
    defaultMessage: 'Insure for',
    description: 'title for checkbox',
    id: '7ikqpJ',
  },
  signatureMayBeRequired: {
    defaultMessage: 'Shipments valued over {amount} may require <a>Signature Confirmation</a>',
    description: 'warning describing that certain shipments with a specific value might need signature confirmation',
    id: 'ZZ8phK',
  },
});
